import { Box, Stack } from '@mui/material';
import React from 'react';
import { useUsersQuery } from '../../../hooks/queries.js';
import TablaUsuarios from './TablaUsuarios.jsx';
import { useAppStore } from '../../../store/appStore.tsx';

const Usuarios = () => {
    const currentUser = useAppStore(appStore => appStore.currentUser);

    /* Recuperación de todos los usuarios en la base de datos */
    const bodyUsers = { comando: "CMD_GET_USERS" };
    const usersQuery = useUsersQuery(bodyUsers);

    if (usersQuery.isPending) return <Box paddingTop={3}><p>Cargando Usuarios...</p></Box>;
    if (usersQuery.isError) return <Box paddingTop={3}><p>Error Cargando Usuarios: {usersQuery.error.message}</p></Box>;

    const users = usersQuery.data?.result?.rows || [];

    return (
        <Stack
            direction="column"
            spacing={0}
            flexGrow={1} 
            pt={2} 
            pb={2}
        >
            <Box bgcolor='white' padding={2} style={{ width: '100%', borderRadius: 0 }}>
                {/* Pasamos currentUser a la tabla para validar si mostramos el botón de "Agregar" */}
                <TablaUsuarios
                    usuarios={users}
                    titulo="Gestión de Usuarios"
                    currentUser={currentUser} 
                />
            </Box>
        </Stack>
    )
}

export default Usuarios;